import { render, staticRenderFns } from "./PublicationCard.vue?vue&type=template&id=61c85726&"
import script from "./PublicationCard.vue?vue&type=script&lang=js&"
export * from "./PublicationCard.vue?vue&type=script&lang=js&"
import style0 from "./PublicationCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports